<template>
    <div>
        <modal name="popup" 
            v-bind="popupProps">
            <PaymentPlanPopup @payment-plan-selected="handlePaymentPlanSelected"
                v-if="step === 0" />
            <PaymentPopup 
                v-if="step === 1"
                :plan="selectedPlan"
                @submit="handlePaymentSubmit"
                @back="stepBack" />
            <PaymentSuccessPopup 
                v-if="step === 2"
                :plan-name="planName"
                :order-number="orderNumber" 
                @proceed="step = 3" />
            <KeywordsImportTypePopup 
                v-if="step === 3"
                @close="closeAll"
                @addKeywordsForMe="step = 4" />
            <ScheduleACallPopup v-if="step === 4"
                @close="closeAll" />
        </modal>
    </div>
</template>

<script>
import PaymentPlanPopup from '@/features/agency/PaymentPlanPopup'
import PaymentPopup from '@/features/agency/PaymentPopup'
import baseModalProps from '@/common/BaseModalProps'
import { mapState, mapActions } from 'vuex'

import PaymentSuccessPopup from '@/features/agency/PaymentSuccessPopup'
import KeywordsImportTypePopup from '@/features/agency/KeywordsImportTypePopup'
import ScheduleACallPopup from '@/features/agency/ScheduleACallPopup'

export default {
    name: 'PaymentPlanManager',
    components: {
        PaymentPlanPopup,
        PaymentPopup,
        PaymentSuccessPopup,
        KeywordsImportTypePopup,
        ScheduleACallPopup
    },
    data() {
        return {
            bigPopupProps: {
                ...baseModalProps,
                width: 920,
                scrollable: true,
                styles: {
                    zIndex: 9999
                }
            },
            smallPopupProps: {
                ...baseModalProps,
                width: 500,
                scrollable: true,
                styles: {
                    zIndex: 9999
                }
            },

            selectedPlan: null,
            step: 0
        }
    },
    created() {
        if (this.planName && this.orderNumber) {
            this.step = 2
        }
    },
    mounted() {
        this.$modal.show('popup')
    },
    computed: {
        ...mapState('agency', ['planName', 'orderNumber']),
        popupProps() {
            return this.step < 2 ? this.bigPopupProps : this.smallPopupProps
        }
    },
    methods: {
        ...mapActions('rankZoneCommon', ['getSession']),
        handlePaymentPlanSelected(paymentPlan) {
            this.selectedPlan = paymentPlan
            this.step = 1;
        },
        async handlePaymentSubmit(subscriptionResult) {
            if (subscriptionResult.success) {
                // await this.getSession({ clientId: this.clientId })
                this.getSession({ clientId: this.clientId })
                this.step = 2;
            }
        },
        stepBack() {
            this.step = 0;
        },
        closeAll() {
            this.$modal.hide('popup')
        }
    }
}
</script>

<style lang="scss" scoped>
:deep(.v--modal-overlay) {
  z-index: 9998 !important;
}

:deep(.v--modal-box) {
  z-index: 9999 !important;
}
</style>